import {createWebHashHistory, createRouter} from "vue-router";
import Calculate from "@/components/Calculate.vue";
import Result from "@/components/Result.vue";
import store from '@/store/index.js'

const routes = [
    {
        path: "/",
        redirect: {
            name: "calculate"
        }
    },
    {
        path: "/calculate",
        name: "calculate",
        component: Calculate,
    },
    {
        path: "/result",
        name: "result",
        component: Result,
        beforeEnter: (to, from, next) => {
            if (store.state.authenticated == false) {
                next("/calculate");
            } else {
                next();
            }
        }
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;